// extracted by mini-css-extract-plugin
export default {"title":"AppSectionTitle_title__5YoKp"};